export default __webpack_public_path__ + "static/media/codeing-animation.17dfa608.gif";